
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Edit, Hotel, Loader2, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useToast } from "@/components/ui/use-toast";

import { fetchProperties } from "../api/property";
interface Property {
  id: string;
  name: string;
  description: string;
  rooms: number;
}

// Mock API service for fetching hotels
const fetchHotels = async () => {
  const properties = await fetchProperties();
  console.log("Fetched properties:", properties);

  return properties.map((property: Property) => ({
    id: property.id,
    name: property.name,
    description: property.description,
    rooms: property.rooms,
  }));
};

const Properties = () => {
  const { toast } = useToast();
  
  // Fetch propertys data
  const { data: hotels, isLoading, error } = useQuery({
    queryKey: ['hotels'],
    queryFn: fetchHotels,
  });

  if (error) {
    toast({
      variant: "destructive",
      title: "Error fetching hotels",
      description: "Could not load property properties. Please try again later.",
    });
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Properties</h1>
        <Button asChild>
          <Link to="/properties/add">
            <Hotel className="mr-2 h-4 w-4" />
            Add Property
          </Link>
        </Button>
      </div>
      
      {isLoading ? (
        <div className="flex justify-center items-center py-8">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : (
        <Table>
          <TableCaption>List of property properties</TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Location</TableHead>
              <TableHead>Rooms</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {hotels?.map((property) => (
              <TableRow key={property.id}>
                <TableCell className="font-medium">{property.name}</TableCell>
                <TableCell>{property.description}</TableCell>
                <TableCell>{property.rooms}</TableCell>
                <TableCell className="text-right">
                  <div className="flex justify-end space-x-2">
                    <Button variant="ghost" size="sm" asChild>
                      <Link to={`/properties/${property.id}/edit`}>
                        <Edit className="mr-2 h-4 w-4" />
                        Edit
                      </Link>
                    </Button>
                    <Button variant="ghost" size="sm" asChild>
                      <Link to={`/properties/${property.id}/settings`}>
                        <Settings className="mr-2 h-4 w-4" />
                        Settings
                      </Link>
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default Properties;
